import { AiFillAppstore } from "react-icons/ai";
import { FaMobile, FaGlobe} from "react-icons/fa";
import { SiProgress, SiAntdesign } from "react-icons/si";

// Features Data
export const featuresData = [
  {
    id: 1,
    title: "Business Stratagy",
    des: "Unlock growth and efficiency with tailored, data-driven business strategies designed to elevate your success.",
  },
  {
    id: 2,
    icon: <AiFillAppstore />,
    title: "App Development",
    des: "Build innovative, user-friendly mobile and web apps with our expert development team, delivering customized solutions that drive engagement and growth.",
  },
  {
    id: 3,
    icon: <SiProgress />,
    title: "SEO Optimisation",
    des: "Boost your online visibility and drive organic traffic with tailored SEO strategies that improve rankings and enhance search engine performance.",
  },
  {
    id: 4,
    icon: <FaMobile />,
    title: "Mobile Development",
    des: "Craft custom, high-performance mobile apps that deliver exceptional user experiences and drive business growth on iOS and Android platforms.",
  },
  {
    id: 5,
    icon: <SiAntdesign />,
    title: "UX Design",
    des: "Design intuitive and visually stunning user interfaces that enhance user experience, boost engagement, and create lasting impressions.",
  },
  {
    id: 6,
    icon: <FaGlobe />,
    title: "Responsive Web Design",
    des: "Create seamless, mobile-friendly websites that adapt to any device, ensuring a smooth user experience and driving greater engagement.",
  },
];
